<template>
  <div class="not-found-page">
    <div class="centered h-100">
      <h1><i class="not-found-icon nc-icon nc-puzzle-10"></i>404</h1>
      <p>A página não foi encontrada.</p>
      <router-link :to="{name: 'Home'}" class="breadcrumb-link">
        Tela inicial
      </router-link>
    </div>
  </div>
</template>

<script>
import AuthLayout from "src/pages/Layouts/AuthLayout.vue";

export default {
  components: {
    AuthLayout,
  },
};
</script>
<style lang="scss">
.not-found-page {
  .full-page > .content,
  .centered {
    height: calc(100vh - 200px);
    padding-top: 50px;
  }
  .not-found-icon {
    margin-right: 10px;
  }
  .centered {
    h1,
    i {
      font-size: 50px;
    }
    p {
      font-size: 20px;
    }
    display: flex;
    padding-bottom: 150px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: black;
  }
}
</style>
